// extracted by mini-css-extract-plugin
module.exports = {"component":"RestaurantList_component__2p9AI","isLoading":"RestaurantList_isLoading__3SXUI"};